export enum DocumentTypeEnum {
    WAYBILL = 'WAYBILL',
    COMMERCIAL_INVOICE = 'COMMERCIAL_INVOICE',
    INVOICE = 'INVOICE',
    PROOF_OF_DELIVERY = 'PROOF_OF_DELIVERY',
    SHIPMENT_SUMMARY = 'SHIPMENT_SUMMARY',
    DANGEROUS_GOODS_DECLARATION = 'DANGEROUS_GOODS_DECLARATION',
    PROFORMA_INVOICE = 'PROFORMA_INVOICE',
    CERTIFICATE_OF_ORIGIN = 'CERTIFICATE_OF_ORIGIN',
    PRIOR_NOTICE = 'PRIOR_NOTICE',
    CUSTOMER = 'CUSTOMER',
    UPLOAD = 'UPLOAD'
}
